import React, { useEffect, useState } from "react";
import style from "../BulkUploadTabs.module.css";
import Button from "../../../component/button/Button";
import { FaCloudArrowUp } from "react-icons/fa6";
import { showToast } from "../../../utils/Toastify/Toastify";
import { getAwsBucketList, postAws } from "../../../api/bulk-upload-api";
import { IoIosArrowDown } from "react-icons/io";
import InputText from "../../../component/inputText/InputText";

const CloudStorage = () => {
  const [selected, setSelected] = useState("aws");
  const [showAwsForm, setShowAwsForm] = useState(true);
  const [bucketList, setBucketList] = useState([]);
  const [selectedBucketId, setSelectedBucketId] = useState("");
  const [awsCredentials, setAwsCredentials] = useState({
    access_key: "",
    secret_key: "",
    region: "",
    bucket_name: "",
    select: "",
  });
  const handleSelectChange = (bucketObject, rawValue) => {
    setSelectedBucketId(bucketObject.id || "");
    setAwsCredentials({
      ...awsCredentials,
      access_key: bucketObject.access_key || "",
      secret_key: bucketObject.secret_key || "",
      region: bucketObject.region || "",
      bucket_name: bucketObject.bucket_name || "",
      select: rawValue, // store the JSON string to keep the select value in sync
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAwsBucketList();
        setBucketList(response?.data?.data || []);
        // if (response?.status === 200) {
        //   showToast("AWS S3 buckets fetched successfully", "success");
        // }
      } catch (error) {
        showToast("Failed to fetch AWS S3 buckets", "error");
      }
    };

    if (selected === "aws") {
      fetchData();
    }
  }, []);

  const handleConnectClick = async () => {
    try {
      const response = await postAws(
        selectedBucketId ? { id: selectedBucketId } : awsCredentials
      );
      if (selected === "aws") {
        showToast("Connected to AWS S3 successfully", "success");
      }
    } catch (error) {
      showToast("Failed to connect to AWS S3", "error");
    } finally {
      setAwsCredentials({
        access_key: "",
        secret_key: "",
        region: "",
        bucket_name: "",
        select: "",
      });
    }
    setSelectedBucketId("");
  };

  const handleAWS = () => {
    setSelected("aws");
    setShowAwsForm(true);
  };
  const renderProviderUI = () => {
    const providerName = selected.charAt(0).toUpperCase() + selected.slice(1);
    return (
      <div className={style.connectBox}>
        <FaCloudArrowUp className={style.cloudIcon} />
        <div className={style.providerName}>Connect to {providerName}</div>
        <p>Authorize access to your cloud storage to browse and import files</p>
        {selected === "aws" && showAwsForm && (
          <div className={style.awsForm}>
            <InputText
              className={style.awsFormInput}
              type="text"
              placeholder="Access Key ID"
              value={awsCredentials.access_key}
              onChange={(e) =>
                setAwsCredentials({
                  ...awsCredentials,
                  access_key: e.target.value,
                })
              }
            />
            <InputText
              className={style.awsFormInput}
              type="password"
              placeholder="Secret Access Key"
              value={awsCredentials.secret_key}
              onChange={(e) =>
                setAwsCredentials({
                  ...awsCredentials,
                  secret_key: e.target.value,
                })
              }
            />
            <InputText
              className={style.awsFormInput}
              type="text"
              placeholder="Region (e.g., us-east-1)"
              value={awsCredentials.region}
              onChange={(e) =>
                setAwsCredentials({ ...awsCredentials, region: e.target.value })
              }
            />
            <InputText
              className={style.awsFormInput}
              type="text"
              placeholder="Bucket Name"
              value={awsCredentials.bucket_name}
              onChange={(e) =>
                setAwsCredentials({
                  ...awsCredentials,
                  bucket_name: e.target.value,
                })
              }
            />
            <Button
              type="select"
              iconRight={<IoIosArrowDown />}
              selectLabel="Select Bucket"
              options={bucketList.map((bucket) => ({
                label: bucket.bucket, // show only bucket name
                value: JSON.stringify(bucket), // store full object as string
              }))}
              variant="outline"
              value={awsCredentials.select} // controlled select value
              onClick={(e) => {
                const rawValue = e.target.value;
                if (rawValue) {
                  handleSelectChange(JSON.parse(rawValue), rawValue);
                } else {
                  setAwsCredentials({ ...awsCredentials, select: "" });
                }
              }}
            />
          </div>
        )}
        <div className={style.connectButtonContainer}>
          <Button className={style.connectButton} onClick={handleConnectClick}>
            🔗 Connect Account
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={style.cloudStorage}>
        <h3>Cloud Storage Integration</h3>
        <p>Import content directly from your cloud storage providers</p>
        <div className={style.providerList}>
          {/* <button
          onClick={() => setSelected("google")}
          className={selected === "google" ? style.activeProvider : ""}
        >
          Google Drive
        </button>
        <button
          onClick={() => setSelected("dropbox")}
          className={selected === "dropbox" ? style.activeProvider : ""}
        >
          Dropbox
        </button> */}
          <button
            onClick={() => handleAWS()}
            className={selected === "aws" ? style.activeProvider : ""}
          >
            AWS S3
          </button>
        </div>
        <div className={style.providerContent}>{renderProviderUI()}</div>
      </div>
    </>
  );
};

export default CloudStorage;
